import React from 'react';
import PropTypes from 'prop-types';
import * as styles from './styles.module.scss';
import MinimalHeader from '../MinimalHeader';

function MinimalLayout({ children }) {
  return (
    <div className={styles.minimal}>
      <MinimalHeader />
      {children}
    </div>
  );
}

MinimalLayout.propTypes = {
  children: PropTypes.node.isRequired
};

export default MinimalLayout;
